export default __webpack_public_path__ + "static/media/riotvan_gaming.463c138f.png";